import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import Tooltip from 'components/Shared/Tooltip/Index'

export const StyledTableCell = styled.td`
  padding: ${props => props.noPadding ? '0' : '6px 12px'};
  font-size: 14px;
  position: relative;
  vertical-align: middle;
  box-sizing: border-box;
  height: ${props => props.height ? 'auto' : '40px'};
  max-height: ${props => props.height ? props.height : '40px'};

  text-align: ${props => props.align};
  ${props => props.width && css`
    width: ${props.width};
  `}
  ${props => props.maxWidth && css`
    max-width: ${props.maxWidth};
  `}
`

const TableCell = ({ children, align, width, maxWidth, className, colSpan, noPadding, tooltip, tooltipId, height }) => {
  return (
    <StyledTableCell
      align={align}
      width={width}
      maxWidth={maxWidth}
      className={className}
      colSpan={colSpan}
      noPadding={noPadding}
      data-tooltip-content={tooltip}
      data-tooltip-id={tooltipId}
    >
      {children}
      {!!tooltipId && <Tooltip id={tooltipId} />}
    </StyledTableCell>
  )
}

TableCell.propTypes = {
  children: PropTypes.node,
  align: PropTypes.string,
  width: PropTypes.string,
  maxWidth: PropTypes.string,
  colSpan: PropTypes.string,
  noPadding: PropTypes.bool,
  tooltip: PropTypes.string,
  tooltipId: PropTypes.string,
  height: PropTypes.string,
}

export default TableCell
